module.exports = __webpack_public_path__ + "img/ai_icon.70f70a1b.png";